import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoIcon from '@mui/icons-material/Info';

import { EventBusProvider } from './providers/event-bus';
import { MonitorProvider } from './providers/monitor';
import router from './router';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 30000,
        },
    },
});

export const App = () => {
    return (
        <EventBusProvider>
            <MonitorProvider>
                <QueryClientProvider client={queryClient}>
                    <Toaster
                        richColors
                        position="top-center"
                        icons={{
                            success: <CheckCircleIcon color="success" />,
                            error: <ErrorOutlineIcon color="error" />,
                            info: <InfoIcon color="info" />,
                        }}
                    />
                    <RouterProvider router={router} />
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </MonitorProvider>
        </EventBusProvider>
    );
};
